const SolutionList = () => import("@/vuepage/solution-manage/solutionList");
const AddSolution = () => import("@/vuepage/solution-manage/addSolution");
const AddScene = () => import("@/vuepage/solution-manage/addScene");
export default [
  {
    path: "/solution-list",
    component: SolutionList,
    name: "/solution-list",
    meta: [{ name: "行业解决方案管理" }, { name: "行业解决方案列表", activeRoute: "/solution-list" }],
  },

  {
    path: "/add-solution",
    component: AddSolution,
    name: "/add-solution",
    meta: [{ name: "行业解决方案管理" }, { name: "新增行业解决方案管理", activeRoute: "/add-solution" }],
  },
  {
    path: "/add-scene",
    component: AddScene,
    name: "/add-scene",
    meta: [{ name: "行业解决方案管理" }, { name: "添加场景", activeRoute: "/add-scene" }],
  },
];
